var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-contact-bg-orange';
                    var viewUrl = 'sprite.svg#view-icon-contact-bg-orange';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 60 41',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };